import React, { useState } from "react";

const Notepad = () => {
  const [text, setText] = useState("");

  const handleClear = () => {
    if (window.confirm("Clear all text?")) {
      setText("");
    }
  };

  const handleDownload = () => {
    const element = document.createElement("a");
    const file = new Blob([text], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "notepad.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="w-full h-full flex flex-col bg-white">
      {/* Toolbar */}
      <div
        className="flex gap-2 p-2 border-b"
        style={{
          background: "#c0c0c0",
          borderBottomColor: "#808080",
        }}
      >
        <button
          onClick={handleDownload}
          className="px-3 py-1 text-xs font-bold border-2"
          style={{
            background: "#c0c0c0",
            borderTopColor: "#dfdfdf",
            borderLeftColor: "#dfdfdf",
            borderRightColor: "#808080",
            borderBottomColor: "#808080",
            cursor: "pointer",
          }}
          title="Download as TXT"
        >
          💾 Save
        </button>
        <button
          onClick={handleClear}
          className="px-3 py-1 text-xs font-bold border-2"
          style={{
            background: "#c0c0c0",
            borderTopColor: "#dfdfdf",
            borderLeftColor: "#dfdfdf",
            borderRightColor: "#808080",
            borderBottomColor: "#808080",
            cursor: "pointer",
          }}
          title="Clear all text"
        >
          🗑️ Clear
        </button>
      </div>

      {/* Text Editor */}
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="flex-1 p-2 border-0 resize-none focus:outline-none"
        style={{
          fontFamily: "Courier New, monospace",
          fontSize: "12px",
          lineHeight: "1.5",
        }}
        placeholder="Start typing..."
      />

      {/* Status Bar */}
      <div
        className="px-2 py-1 text-xs border-t flex justify-between"
        style={{
          background: "#c0c0c0",
          borderTopColor: "#dfdfdf",
          color: "#000000",
        }}
      >
        <span>{text.length} characters</span>
        <span>{text.split("\n").length} lines</span>
      </div>
    </div>
  );
};

export default Notepad;
